<template>
  <div id="Bobblehead">
    <div id="franco-text">
      <p>
        <span>Exclusive Wander Franco Bobblehead</span> (for Season Memberships
        of $1,000+). Season Members will be notified regarding bobblehead
        distribution prior to Opening Day 2022.
      </p>
    </div>
    <div id="franco-img">
      <img src="@/assets/images/FrancoBat.jpg" alt="Wander Franco" />
      <!-- <img
        src="@/assets/images/no-player/7. Gift Option_Image.jpg"
        alt="Wander Franco"
      /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Bobblehead",
};
</script>

<style lang="scss" scoped>
#Bobblehead {
  width: 100vw;
  display: flex;
  margin-bottom: -100px;
  @media only screen and (max-width: $sm) {
    margin-bottom: -50px;
  }
  #franco-text {
    background-color: $light-blue;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-basis: 50%;
    p {
      margin: 0 50px;
      font-family: "UniversLTStd-LightCn";
      font-size: 24px;
      color: $dark-blue;
      @media only screen and (max-width: $md) {
        font-size: 14px;
        margin: 0 10px;
      }
    }
    span {
      font-family: "UniversLTStd-BoldCn";
    }
  }
  #franco-img {
    flex-basis: 50%;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      object-position: 0 10%;
    }
  }
}
</style>
